import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { RouteLocationNormalized } from 'vue-router';
import { useUserStore } from '@/vue/stores/user';

export const useIsAnonymousStore = defineStore('isAnonymous', () => {
    const isAnonymousRoute = ref(false);

    const isAnonymous = computed(() => !useUserStore().isUserLoggedIn && isAnonymousRoute.value);

    const updateRouteState = (route: RouteLocationNormalized) => {
        isAnonymousRoute.value = !!route.meta?.anonymous;
    };

    return {
        isAnonymous,
        updateRouteState,
    };
});
